import React,{useEffect, useRef} from 'react'

type Props = {
  letter: string;
  setSuccess: (success:boolean)=> void;
}

const TraceGame02 = ({letter, setSuccess}: Props) => {

  const canvasRef = useRef<HTMLCanvasElement>(null)
  const isDrawing = useRef(false);

  const targetColor = 'rgb(8, 87, 136)';

  useEffect(()=> {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const context = canvas.getContext('2d',{willReadFrequently:true});
      if (!context) return;
      context?.clearRect(0, 0, canvas.width, canvas.height);
      var image = new Image();
      image.onload = function() {
        context?.drawImage(image,0,0)
        const svgWidth = image.width;
        const svgHeight = image.height;
        const svgPixels = svgWidth * svgHeight;
    
        console.log('Total SVG Pixels:', svgPixels);
      }
      image.onerror = function() {
      	context.fillStyle = 'red';
      	context.font = '16px Arial';
       	context.fillText('Image loading error!', 10, 30);
    };
      image.src = '/alphabets/DottedLineA.svg'
      // let letterPath = new Path2D(letter)
      // context.fillStyle = 'black';
      // context?.fill(new Path2D(letterPath))
      canvas.addEventListener('mousedown', onMouseDown);
      canvas.addEventListener('mouseup', onMouseUp);
      canvas.addEventListener('mousemove', onMouseMove);
          
    return () => {
      canvas.removeEventListener('mousedown', onMouseDown);
      canvas.removeEventListener('mouseup', onMouseUp);
      canvas.removeEventListener('mousemove', onMouseMove);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[canvasRef,letter])

  const checkCanvasColor = (canvas: HTMLCanvasElement, targetColor: string) => {
    const context = canvas.getContext('2d');
    if (!context) return false;
    const canvasData = context.getImageData(0, 0, canvas.width, canvas.height);

    const pixels = canvasData.data;
    for (let i = 0; i < pixels.length; i += 4) {
      const r = pixels[i];
      const g = pixels[i + 1];
      const b = pixels[i + 2];
      
      const pixelColor = `rgb(${r}, ${g}, ${b})`;

      if (b > 135 && b < 137) {
        console.log('Found color:',pixelColor)
        return true;
      }
    }
    return false;
  };

  const checkTargetColor = () => {
    const canvas = canvasRef.current;
    if (!canvas) return false;

    const hasTargetColor = checkCanvasColor(canvas, targetColor);
    console.log(hasTargetColor)
    return hasTargetColor;
  };
  

  const getMousePosition = (event: MouseEvent) => {
    const canvas = canvasRef.current;
    if (!canvas) return { x: 0, y: 0 };

    const rect = canvas.getBoundingClientRect();
    return {
      x: event.clientX - rect.left,
      y: event.clientY - rect.top,
    };
  };

  const onMouseDown = (event: MouseEvent) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext('2d',{willReadFrequently:true});
    if (!context) return;

    isDrawing.current = true;

    const { x, y } = getMousePosition(event);

    context.fillStyle = 'red';
    context.beginPath();
    context.arc(x, y, 9.5, 0, 2 * Math.PI);
    context.fill();
  };

  const onMouseUp = () => {
    isDrawing.current = false;

    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext('2d',{willReadFrequently:true});
    if (!context) return;    

    if (checkTargetColor()) {
      console.log('You missed some areas!');
    } else {
      console.log('No target color found!');
      setSuccess(true)
      // alert('Success, You did it!');
    }

  };

  const onMouseMove = (event: MouseEvent) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) return;
    if (!isDrawing.current) return;
  
    const { x, y } = getMousePosition(event);
  
    context.fillStyle = 'red';
    context.beginPath();
    context.arc(x, y, 9.5, 0, 2 * Math.PI);
    context.fill();
  };
  


  return (
      <div className={`w-full cursor-point`}>
        <canvas 
          id='canvasID'
          ref={canvasRef}
          height={420}
          width={420}
          className={`p-2`}
        />
      </div>
  )
}

export default TraceGame02